export const CAREERS_DATA = {
  title: {
    ar: 'وظائف ',
    fr: 'Emplois',
    en: 'Careers',
  },
  description: {
    ar: `هل ترغب في الانضمام إلينا؟
هل تبحث عن تحدٍ جديد في مسيرتك المهنية أو ترغب في التطور ضمن فريق ديناميكي وبيئة عمل ملهمة؟ أنت في المكان الصحيح!
كما قال جان-بول سارتر، الفيلسوف والكاتب الفرنسي (1905-1980):
""ليس الشجاعة هي ما ينقص، بل الإرادة للانطلاق.""
ربما حان الوقت المثالي لاتخاذ هذه الخطوة واكتشاف الفرص الجديدة معنا!
انضموا إلى فريقنا!`,
    fr: `"Envie de nous rejoindre ?
Êtes-vous à la recherche d'un nouveau défi dans votre cheminement de carrière ou intéressé à vous développer au sein d'une équipe dynamique et d'un milieu de travail inspirant ? Vous êtes au bon endroit !
Comme le disait Jean-Paul Sartre, philosophe et écrivain français (1905-1980) :
""Ce n'est pas le courage qui manque, c'est la volonté de se lancer.""
C'est peut-être le moment idéal pour faire le vôtre et découvrir de nouvelles opportunités avec nous !" Rejoignez notre équipe !`,
    en: `Want to join us?
Are you looking for a new challenge in your career path, or interested in growing within a dynamic team and an inspiring work environment? You're in the right place!
As Jean-Paul Sartre, French philosopher and writer (1905-1980), said:
""It’s not courage that’s lacking, it’s the will to take the leap.""
Perhaps this is the perfect moment to take that step and discover new opportunities with us! Join our team! 
`,
  },
  order: 0,
  attachments: [], // TODO : Attach Nous_recrutons.jpg
  image: 'Nous_recrutons.jpg',
  type: 'careers',
  isArchived: false,
  jobs: [
    // {
    //   title: {
    //     ar: 'قدّم الآن!',
    //     fr: 'Postulez maintenant!',
    //     en: 'Apply now!',
    //   },
    //   description: {
    //     ar: 'قدم طلبك للانضمام إلى فريقنا!',
    //     fr: 'Postuler et rejoindre notre équipe !',
    //     en: 'Apply and become part of our team!',
    //   },
    //   order: 2,
    //   link: '',
    //   attachments: [],
    //   type: 'careers',
    //   isArchived: false,
    // },
    {
      title: {
        ar: `وظيفة شاغرة!`,
        fr: `Poste à pourvoir !`,
        en: 'Position available!',
      },
      description: {
        ar: `هل تبحثون عن فرصة مهنية جديدة؟ لدينا وظيفة شاغرة قد تكون المناسبة لكم!
    لا تترددوا، أرسلوا لنا ملف ترشيحكم بالضغط على الرابط التالي !
    `,
        fr: `Vous êtes à la recherche d’une nouvelle opportunité professionnelle ? Nous avons un poste vacant qui pourrait être fait pour vous !
    N'attendez plus, envoyez-nous votre dossier de candidature en cliquant sur le lien ci-dessous!
    `,
        en: `Are you looking for a new career opportunity? We have a vacant position that could be perfect for you!
    Don't wait any longer – send us your application by clicking on the link below!`,
      },
      order: 1,
      attachments: [],
      link: '',
      type: 'careers',
      isArchived: false,
    },
  ],
};
